import clsx from 'clsx'

import { Separator } from '@wartek-id/separator'
import { Text } from '@wartek-id/text'

import { ProvinceImage } from '../ProvinceLogoCard/ProvinceImage'
import { DATA_INDUK_TITLE_PREFIX, VARIANT } from '../../constant'

interface AreaStatsProps {
  title?: string
  image: string
  total: number
  isPending?: boolean
  withImage?: boolean
  imageClass?: string
  wrapperClass?: string
  level?: 'district' | 'country'
}

export const AreaSummaryStatsYayasan = ({
  title = DATA_INDUK_TITLE_PREFIX[VARIANT.YAYASAN],
  image,
  total,
  isPending = false,
  withImage = false,
  imageClass,
  wrapperClass = '',
  level = 'district',
}: AreaStatsProps) => {
  return (
    <div className={clsx('rounded-lg bg-blue-90 p-4', wrapperClass)}>
      <div className="flex flex-wrap items-center gap-4">
        <div className="flex items-center gap-4">
          {withImage && (
            <ProvinceImage
              image={image}
              alt={title}
              level={level}
              className={imageClass}
            />
          )}
          <Text color="inverse" variant="action">
            {title}
          </Text>
        </div>
        {isPending ? null : (
          <>
            <Separator
              orientation="vertical"
              style={{
                width: 1,
                height: 30,
              }}
              className="hidden md:block"
            />
            <Text color="inverse" variant="body-sm-bold">
              Total {new Intl.NumberFormat('id-ID', {}).format(total)}
            </Text>
          </>
        )}
      </div>
    </div>
  )
}
